import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu as MenuIcon, X } from "lucide-react";
import CustomerAuth from "@/components/CustomerAuth";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "Story" },
  { to: "/menu", label: "Menu" },
  { to: "/locations", label: "Outlets" },
  { to: "/journal", label: "Journal" },
  { to: "/franchise", label: "Franchise" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-cream/85 border-b border-clayline/60" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <img src="/logo.png" alt="Chai Times logo" className="w-11 h-11 md:w-12 md:h-12 rounded-full object-contain" />
          <span className="font-lobster text-3xl md:text-5xl tracking-tight text-charcoal hidden sm:block leading-none">
            Chai <span className="text-terracotta">Times</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:text-terracotta ${
                  isActive ? "text-terracotta" : "text-charcoal/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-contact-btn"
            className="rounded-full px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] bg-charcoal text-cream hover:bg-terracotta transition-colors"
          >
            Visit Us
          </Link>
          <CustomerAuth />
        </nav>
        <button
          className="lg:hidden text-charcoal p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <MenuIcon size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden bg-espresso text-cream"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {[...links, { to: "/contact", label: "Contact" }].map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                  className="font-serif text-2xl hover:text-gold transition-colors"
                >
                  {l.label}
                </NavLink>
              ))}
              <div className="pt-4 border-t border-cream/15 [&_button]:border-gold [&_button]:text-gold">
                <CustomerAuth />
              </div>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
